import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Summary from './components/Summary'
import Header from './components/Header'
import Score from './components/Score'
import Performance from './components/Performance'
import AdMonitorRequest from './components/AdMonitorRequest'
import ReportWrapper from './reportWrapper'
import SubscriptionModal from '../../components/SubscriptionModal'
import PerformanceItemModal from './components/PerformanceItemModal'

class Report extends Component {
	state = {
		performanceModalShowing: false,
		performanceModalType: 'variance',
		subscriptionModalShowing: false
	}

	leaveReport = () => {
		let { history, exitReport } = this.props
		history.push('/accounts')
		exitReport()
	}

	showPerformanceModal = (type) => {
		this.setState({
			performanceModalShowing: true,
			performanceModalType: type,
			subscriptionModalShowing: false
		})
	}

	showSubscriptionModal = () => {
		window.mixpanel.track('[AdScore] - AdMonitor Modal Shown', {
			adAccountID: this.props.accountId
		})
		this.setState({
			performanceModalShowing: false,
			subscriptionModalShowing: true
		})
	}

	modalDismissed = () => {
		this.setState({
			performanceModalShowing: false,
			subscriptionModalShowing: false
		})
	}

	subscribedToAdMonitor = () => {
		return (this.props.accountId in this.props.adMonitorRequests)
	}

	subscribeSucceded = () => {
		this.props.adMonitorRequested(this.props.accountId)
	}

	render() {
		let { accountName, accountId, report, sessionEmail, facebookSession, reportLoadTime } = this.props
		let { summary, performance } = report

		return (
			<ReportWrapper>
				<Header name={accountName}>
					<Score score={performance.totalScore} name={accountName} />
				</Header>
				<Summary summary={summary} />
				<Performance scores={performance.scores} showPerformanceModal={this.showPerformanceModal} />
				<AdMonitorRequest
					subscribed={this.subscribedToAdMonitor()}
					loadTime={reportLoadTime}
					exitReport={this.leaveReport}
					showSubscribeModal={this.showSubscriptionModal} />
				<SubscriptionModal
					accountName={accountName}
					accessToken={facebookSession.accessToken}
					accountId={accountId}
					sessionEmail={sessionEmail}
					display={this.state.subscriptionModalShowing}
					modalDismissed={this.modalDismissed}
					submitSuccess={this.subscribeSucceded} />
				<PerformanceItemModal
					display={this.state.performanceModalShowing}
					type={this.state.performanceModalType}
					modalDismissed={this.modalDismissed}
					subscribeButtonClicked={this.showSubscriptionModal}
					subscribed={this.subscribedToAdMonitor()} />
			</ReportWrapper>
		)
	}
}

Report.propTypes = {
	accountId: PropTypes.string,
	accountName: PropTypes.string,
	exitReport: PropTypes.func,
	report: PropTypes.object,
	sessionEmail: PropTypes.string,
	history: PropTypes.object,
	facebookSession: PropTypes.object,
	reportLoadTime: PropTypes.string,
	adMonitorRequests: PropTypes.object,
	adMonitorRequested: PropTypes.func
}


export default Report



// WEBPACK FOOTER //
// ./src/containers/ReportLoader/Report.js